/**
 * Module dependencies.
 */

import { Background, Image, Wrapper } from './contacts-header.style';
import { JSX } from 'react';

/**
 * Export `ContactsHeader` component.
 */

export function ContactsHeader(): JSX.Element {
  return (
    <>
      <Wrapper>
        <Background>
          <Image src={'/contacts_bg.png'} />
        </Background>
      </Wrapper>
    </>
  );
}
